import React from 'react';
import { StyleSheet, View, Text as RNText } from 'react-native';
import Button from 'design-system/Button';
import Text from 'design-system/Text';
import { IconLock, IconSquareCircle } from 'design-system/icons';
import { rem } from 'design-system';
import Modal from 'utils/packages/Modal';
import DottedSquircle from 'design-system/DottedSquircle';
import Squircle from 'design-system/Squircle';
import useColors from 'hooks/useColors';
import { isWeb } from '../../../constants';
const QuestModalContent = ({ quest, onPressInvite, onPressShareFacebook, }) => {
    const renderButton = () => {
        switch (quest.type) {
            case 'social.invite_1_friend':
            case 'social.invite_2_friends':
            case 'social.invite_3_friends':
                return <Button gray title="Invite" onPress={onPressInvite}/>;
            case 'social.facebook_share':
                return (<Button black title="Share on Facebook" onPress={onPressShareFacebook}/>);
            default:
                return (<Button gray title="OK" onPress={() => {
                        Modal.hide();
                    }}/>);
        }
    };
    const colors = useColors();
    const IconWrapper = isWeb ? Squircle : IconSquareCircle;
    return (<View style={[styles.container, isWeb && styles.paddinTop0]}>
      {quest.status === 'LOCKED' ? (<DottedSquircle width={rem(74)} height={rem(74)} style={styles.icon}>
          <IconLock width={33} height={33} color={colors.text.secondary}/>
        </DottedSquircle>) : (<IconWrapper width={64} height={64} style={styles.icon} color={colors.background.dark}>
          <RNText style={styles.emoji}>{quest.icon}</RNText>
        </IconWrapper>)}
      <Text Text-20 centered style={styles.title}>
        {quest.label}
      </Text>
      <Text TextThin-14 Gray centered style={styles.subTitle}>
        {quest.details}
      </Text>
      {renderButton()}
    </View>);
};
const styles = StyleSheet.create({
    container: {
        alignItems: 'center',
        paddingTop: rem(70),
    },
    icon: {
        marginBottom: rem(40),
    },
    emoji: {
        fontFamily: 'System',
        fontSize: rem(25),
        textAlign: 'center',
    },
    title: {
        marginBottom: rem(8),
    },
    subTitle: {
        marginBottom: rem(60),
        paddingHorizontal: rem(16),
    },
    paddinTop0: {
        paddingTop: 0,
    },
});
export default QuestModalContent;
